// extracted by mini-css-extract-plugin
module.exports = {"solText":"MultipleChoiceQuestion_solText__GRLvm","text":"MultipleChoiceQuestion_text__1v8Bt","heading":"MultipleChoiceQuestion_heading__1JvkJ"};